<ng-container *ngIf="field && !field.hidden">
    <ng-container *ngIf="!field.UIOptions?.customTemplate">
		<ng-container *ngTemplateOutlet="formFieldElement"></ng-container>
	</ng-container>

	<ng-container *ngIf="field.UIOptions?.customTemplate">
		<div class="row custom-template-field-container">
			<div [ngClass]="field.UIOptions.customTemplateOptions.fieldContainerClass">
				<div class="row">

					<ng-container *ngIf="field?.DataType === 'SelectChips' || field?.DataType === 'PickList' || field.DataType === 'TableField'">
						<ng-container *ngTemplateOutlet="formFieldElement"></ng-container>
					</ng-container>

					<ng-container *ngIf="field?.DataType !== 'SelectChips' && field?.DataType !== 'PickList' && field?.DataType !== 'TableField' ">
						<div [ngClass]="field.UIOptions.customTemplateOptions.descriptionContainerClass">
							<p class="subtitle">{{field.DisplayText}}</p>
							<p class="description-label" *ngIf="field.description">{{field.description}}</p>
						</div>

						<div [ngClass]="field.UIOptions.customTemplateOptions.fieldElementClass">
							<ng-container *ngTemplateOutlet="formFieldElement"></ng-container>
						</div>
					</ng-container>
				</div>
			</div>
			<div [ngClass]="field.UIOptions.customTemplateOptions.customActionsClass">

			</div>
		</div>
	</ng-container>
</ng-container>

<ng-template #formFieldElement>
	<ng-container [ngSwitch]="field?.DataType">
		<ng-container *ngSwitchCase="'Selector'">
			<cv-dropdown-field
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-dropdown-field>
		</ng-container>

		<ng-container *ngSwitchCase="'Boolean'">

			<cv-select-button-field
				*ngIf="field.SubDataType === 'select-switch'; else simple_checkbox"
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-select-button-field>

			<ng-template #simple_checkbox>
				<cv-input-switch-field
					*ngIf="field.SubDataType !== 'select-switch'"
					[fieldOptions]="options"
					[field]="field"
					[value]="value"
					[control]="formControl"
				>
				</cv-input-switch-field>
			</ng-template>
		</ng-container>

		<ng-container *ngSwitchCase="'RangeNumber'">
			<cv-slider-field
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-slider-field>
		</ng-container>

		<ng-container *ngSwitchCase="'RadioButton'">
			<cv-radio-button-field
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-radio-button-field>
		</ng-container>

		<ng-container *ngSwitchCase="'SelectChips'">
			<cv-select-chips
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-select-chips>
		</ng-container>

		<ng-container *ngSwitchCase="'PickList'">
			<cv-picklist-field
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-picklist-field>
		</ng-container>

		<ng-container *ngSwitchCase="'TableField'">
			<cv-table-field
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-table-field>
		</ng-container>

		<ng-container *ngSwitchCase="'ModalTable'">
			<cv-modal-table-field
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-modal-table-field>
		</ng-container>

		<ng-container *ngSwitchCase="'Date'">
			<cv-calendar-field
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-calendar-field>
		</ng-container>

		<ng-container *ngSwitchDefault>
			<cv-form-input
				[fieldOptions]="options"
				[field]="field"
				[value]="value"
				[control]="formControl"
			>
			</cv-form-input>
		</ng-container>
	</ng-container>
</ng-template>
